<template>
  <div id="app" class="route-home" :class="nav[store.state.navPath][store.state.navStep].component">
    <!-- <header class="center-grid lg:grid-cols-4"> -->
    <header>
        <div class="container mx-auto">
          <Logo class="self-start" />

        </div>
        <!-- <h2 v-show="nav[store.state.navPath][store.state.navStep].name !== 'Home'" -->
            <!-- class="score-topic lg:col-span-2 text-white text-xl font-black hidden lg:block" -->
        <!-- > -->
          <!-- Your {{ nav[store.state.navPath][store.state.navStep].name }} -->

        <!-- </h2> -->
        <!-- <a v-if="nav[store.state.navPath][store.state.navStep].component == 'Results'" href="https://www.bill.com/product-tour" target="_blank" class="text-white get-a-demo">Get a demo</a> -->
    </header>
    <div id="top" class="route" :class="nav[store.state.navPath][store.state.navStep].component + '-box'">
      <Component
        :is="nav[store.state.navPath][store.state.navStep].component"
        transition="stuff"
        :class="nav[store.state.navPath][store.state.navStep].component"
        class="alive route text-left"
        :question="nav[store.state.navPath][store.state.navStep].question"
      />
    </div>
    <footer class="p-4">
      <div class="container">
        <small>&copy; {{ currentYear }} BILL</small>
      </div>
    </footer>
  </div>
</template>

<script>
import { onMounted, onUpdated } from '@vue/composition-api';
import gsap from 'gsap';
import store from './store';

export default {
  name: 'Assessment',
  components: {
    PreviousQuestionButton: () => import('./components/PreviousQuestionButton.vue'),
    BottomNav: () => import('./components/BottomNav.vue'),
    Logo: () => import('./components/Logo.vue'),
    Home: () => import('./views/Home.vue'),
    Opening: () => import('./views/Opening.vue'),
    Control: () => import('./views/Control.vue'),
    Visibility: () => import('./views/Visibility.vue'),
    Efficiency: () => import('./views/Efficiency.vue'),
    TeamsOpen: () => import('./views/TeamsOpen.vue'),
    Results: () => import('./views/Results.vue'),
  },
  computed: {

    currentYear() {
      return new Date().getFullYear();

    },

  },
  setup() {
    const nav = store.getters.getnav;

    const active = store.getters.getActiveSection;

    function routeAnimations() {
      const tl = gsap.timeline();

      tl
        .set(['.route', '.asset'], {
          opacity: 0,
          x: 32,

        })
        .to(['.route', '.asset'], {
          opacity: 1,
          x: 0

        })
      ;
    }

    // Tell iframed parent how big it should be to avoid double scrolling
    setInterval(function() {
      let app = document.getElementById('app');
      let header = document.querySelector('#app header').offsetHeight; // Height of the header
      let bodyContent = document.querySelector('#app #top > .route > div').clientHeight; // Height of the inner content (to avoid flexbox)

      // Home has a different module with padding
      if ( app.classList.contains('Home') ) {
        bodyContent = document.querySelector('#app #top > .route .content').clientHeight; // Height of the inner content (to avoid flexbox)

      } else {
        bodyContent = document.querySelector('#app #top > .route > div').clientHeight; // Height of the inner content (to avoid flexbox)

      }

      let bodyRoute = document.querySelector('#app #top > .route'); // Route element for grabbing padding from

      // Home has a different content div
      if ( app.classList.contains('Home') ) {
        bodyRoute = document.querySelector('#app #top > .route > div'); // Route element for grabbing padding from

      } else {
        bodyRoute = document.querySelector('#app #top > .route'); // Route element for grabbing padding from

      }

      let paddingTop = window.getComputedStyle(bodyRoute, null).getPropertyValue('padding-top'); // Padding top value
      let paddingBottom = window.getComputedStyle(bodyRoute, null).getPropertyValue('padding-bottom'); // Padding bottom value
      let bodyPadding = parseInt(paddingBottom.substring(0, paddingTop.length - 2)) + parseInt(paddingTop.substring(0, paddingBottom.length - 2)); // Combined padding values
      let footer = document.querySelector('#app footer').offsetHeight; // Height of the footer
      let calcHeight = header + bodyContent + footer + bodyPadding; // Combine all pieces

      window.top.postMessage('setHeight:' +  calcHeight, '*');

    }, 2500);

    onMounted(() => {

    });

    onUpdated(() => routeAnimations());

    return {
      store,
      nav,
    };
  },
};
</script>

<style lang="scss">
@import "./styles/styles.scss";

.score-topic {
  text-transform: uppercase;
  font-size: 0.875rem;

}

  // Legacy

header {
  position: relative;
  z-index: 200;
}
.alive {
  z-index:75;
}
.dead {
  z-index:60;
}

.image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;

}

.get-a-demo {
  display: none;
  justify-self: flex-end;

  @media (min-width: $bp-md) {
    display: inline-flex;

  }

}

</style>
